import { reduxAction } from "@shared/utilities/redux";

export default function(state = {}, action: reduxAction) {

    switch (action.type) {
  
      case 'SET_QUOTATION': {

        return Object.assign({}, action.payload);
      }
  
      default:
        return state
    }
};